import React, { useEffect, useState } from "react";
import config from "../config/config";
import { Container, Row, Col, Button } from "react-bootstrap";
import Dashboardheader from "../directives/dashboardheader";
import { TextField } from "@mui/material";
import Cookies from "js-cookie";
import {
  addTransferRequestAction,
  getTransferDataAction,
  sendCreditTransferOtpAction,
} from "../Action/user.action";
import Swal from "sweetalert2";
import CountdownTimer from "./Others/CountdownTimer";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import SendCreditOtpModal from "./Modals/SendCreditOtpModal";

const CreditTransfer = () => {
  const [mntAmount, setMntAmount] = useState();
  const [userDetails, setuserDetails] = useState({});
  const [validationError, setvalidationError] = useState({});
  const [balanceType, setbalanceType] = useState(1);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isChecked, setIsChecked] = useState(false); // State for checkbox
  const [walletAddress, setWalletAddress] = useState("");
  const [walletError, setWalletError] = useState("");
  const [showModal, setshowModal] = useState(false);
  const location = useLocation();
  const [timer, setTimer] = useState(60);
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(['', '', '', '']);
  const [otpIs, setOtpIs] = useState('');
  const [loading, setLoading] = useState(false);
  const { id } = location.state || {};
  const walletRegex = /^0x[a-fA-F0-9]{40}$/;

  const navigate = useNavigate();

  useEffect(() => {
    getStepData();
  }, []);

  const inputHandler = (e) => {
    let { value } = e.target;

    var getDecimalVal = value.toString().indexOf(".");
    var decimalPart = value.toString().substring(getDecimalVal + 1);
    if (decimalPart.length > 2 && getDecimalVal != "-1") {
    } else {
      if (/^\d{0,7}(\{0,2})?$/.test(value)) {
        setMntAmount(value);
      }
    }
  };

  function validate() {
    let withdrawAmountError = "";
    let walletErrorMsg = "";

    // ---- Wallet Address Validation ----
    if (!walletAddress || walletAddress.trim() === "") {
      walletErrorMsg = "Wallet Address is required.";
    } else if (!walletRegex.test(walletAddress)) {
      walletErrorMsg = "Enter a valid wallet address";
    }

    // ---- Amount Validation ----
    if (
      parseFloat(mntAmount).toFixed(2) === "" ||
      parseFloat(mntAmount).toFixed(2) === "0.00"
    ) {
      withdrawAmountError = "Amount is required.";
    } else if (!isNaN(parseFloat(mntAmount).toFixed(2)) === false) {
      withdrawAmountError = "Amount is not valid please enter valid amount.";
    } else if (
      parseFloat(parseFloat(mntAmount).toFixed(2)) <
      parseFloat(
        parseFloat(userDetails?.mining_reward_min__mnt_withdraw).toFixed(2)
      )
    ) {
      withdrawAmountError = `Amount should be >= ${parseFloat(
        userDetails?.mining_reward_min__mnt_withdraw
      ).toFixed(2)} MNT`;
    } else if (userDetails.mnt_withdraw_permitted != 1) {
      withdrawAmountError =
        "Withdraw Service Temporarily Unavailable. Please try again later.";
    }

    // Check balance
    if (balanceType === 1) {
      if (
        parseFloat(parseFloat(mntAmount).toFixed(2)) >
        parseFloat(parseFloat(userDetails?.step_balance).toFixed(2))
      ) {
        withdrawAmountError = "Insufficient funds in your Stepmint Wallet.";
      }
    }

    // Set error state
    setWalletError(walletErrorMsg);
    setvalidationError({ withdrawAmountError });

    if (walletErrorMsg || withdrawAmountError) {
      return false;
    }
    return true;
  }

  const transferFunc = async () => {
    // if (!isChecked) {
    //   toast.dismiss();
    //   toast.error("Please check the box to agree to the Terms and Conditions.");
    //   return;
    // }
    // if (parseFloat(mntAmount) > parseFloat(userDetails.wallet_balance)) {
    //   toast.dismiss();

    //   toast.error("Amount exceeds wallet balance");
    //   return;
    // }

    // if (parseFloat(mntAmount) < userDetails.min_withdrawal_limit) {
    //   toast.dismiss();

    //   toast.error(
    //     `Minimum transfer limit is ${userDetails.min_withdrawal_limit}`
    //   );
    //   return;
    // }

    // if (parseFloat(mntAmount) > userDetails.max_withdrawal_limit) {
    //   toast.dismiss();

    //   toast.error(
    //     `Maximum transfer limit is ${userDetails.max_withdrawal_limit}`
    //   );
    //   return;
    // }

    // const isValid = validate();
    // if (isValid) {
    setvalidationError({});
    const walletName =
      id === 7
        ? "Step Legacy Wallet"
        : id === 5
          ? "NFT Box Wallet"
          : "Business Coin Wallet";
    Swal.fire({
      title: `Amount Confirmation : ${parseFloat(
        parseFloat(mntAmount).toFixed(2)
      )} ANANT`,
      text: `Are you ready to send the amount from ${walletName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Send it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res;
        if (balanceType === 1) {

          res = await addTransferRequestAction({
            transfer_amount: parseFloat(parseFloat(mntAmount).toFixed(2)),
            receiver_address: walletAddress,
            walletType: id, //add withdral type as id and input field data as wallet address
            otp: otpIs
          });
        }
        if (res.success) {
          Swal.fire("Amount Transfer!", res.msg, "success");
          setTimeout(() => {
            window.location.href = `${config.baseUrl}CreditTransfer`;
          }, 1500);
        } else {
          Swal.fire("Failed to Transfer!", res.msg, "error");
        }
      }
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
  };

  const maxToken = async () => {
    if (balanceType === 1) {
      if (userDetails.wallet_balance > userDetails.max_transfer_limit) {
        setMntAmount(userDetails.max_transfer_limit);
      } else {
        setMntAmount(userDetails.wallet_balance);
      }
    } else {
      setMntAmount(userDetails.main_balance);
    }
  };

  const getStepData = async () => {
    try {
      let res = await getTransferDataAction(id);
      setuserDetails(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBackNavigation = () => {
    navigate(-1);
  };

  const handleShowModal = async () => {
    if (!isChecked) {
      toast.dismiss();
      toast.error("Please check the box to agree to the Terms and Conditions.");
      return;
    }
    if (parseFloat(mntAmount) > parseFloat(userDetails.wallet_balance)) {
      toast.dismiss();

      toast.error("Amount exceeds wallet balance");
      return;
    }

    if (parseFloat(mntAmount) < userDetails.min_withdrawal_limit) {
      toast.dismiss();

      toast.error(
        `Minimum transfer limit is ${userDetails.min_withdrawal_limit}`
      );
      return;
    }

    if (parseFloat(mntAmount) > userDetails.max_withdrawal_limit) {
      toast.dismiss();

      toast.error(
        `Maximum transfer limit is ${userDetails.max_withdrawal_limit}`
      );
      return;
    }

    const isValid = validate();
    if (isValid) {
      sendCreditTransfer()
    }
  }

  const sendCreditTransfer = async() => {
     setOtp(['', '', '', '']);
     setOtpIs('');
     setLoading(true);
     const response = await sendCreditTransferOtpAction({ receiver_address: walletAddress });
      if (response && response.data && response.data.email) {
        setshowModal(true);
        setEmail(response.data.email);
        setTimer(60);
        setIsTimerActive(true);
        setLoading(false);
      }else{
        toast.error(response.msg);
        setLoading(false);
      }
  }

  return (
    <>
      <Dashboardheader />

      <div className="shape_bg">
        <img src="assets/images/shape.svg" className="shape" />
        <img src="assets/images/shape1.svg" className="shape1" />
        <img src="assets/images/shape2.svg" className="shape2" />
      </div>
      <div className="page-wrapper">
        <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
          {/* ---------- */}
          <div className=" mb-5">
            <Container className="">
              <p
                style={{
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleBackNavigation}
              >
                <IoIosArrowRoundBack size={35} />
              </p>

              <div className=" card card-view rounded-20 border-0">
                <div className="card-body">
                  <Row className="align-items-center">
                    <Col lg={6} className="">
                      <div className="withdraw_form">
                        <div className="text-center mb-2 pb-1">
                          <h3 style={{ fontWeight: 600 }}>
                            From{" "}
                            {id === 7
                              ? "Step Legacy Wallet"
                              : id === 5
                                ? "NFT Box Wallet"
                                : "Business Coin Wallet"}
                          </h3>

                          {/* <h6 className="mb-4 text-grey">
                            Get your balance in your registered Wallet
                          </h6> */}
                        </div>
                        <Col lg={12} className="mb-4">
                          <TextField
                            id="outlined-helperText"
                            label="Wallet Address"
                            type="text"
                            style={{ width: "100%" }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="0x0E276DF710AD6dD91A3..."
                            autoComplete="off"
                            value={walletAddress}
                            onChange={(e) => setWalletAddress(e.target.value)}
                          />

                          {walletError && (
                            <div style={{ marginTop: 8 }}>
                              <span
                                className="validationErr"
                                style={{
                                  color: "red",
                                  marginTop: "5px",
                                  marginBottom: 5,
                                  fontSize: 14,
                                }}
                              >
                                {walletError}
                              </span>
                            </div>
                          )}
                        </Col>

                        <div className="mxbtn position-relative">
                          <div>
                            <Row>
                              <Col lg={6}></Col>
                              <Col lg={6}>
                                <div className="pull-right mntbalance mb-0">
                                  Balance :&nbsp;
                                  <span id="web13Balance">
                                    {userDetails.wallet_balance} ANANT
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <TextField
                              id="outlined-password-input"
                              label="Amount"
                              type="text"
                              style={{ width: "100%" }}
                              autoComplete="off"
                              placeholder="Enter Amount"
                              disabled={userDetails.show_timer}
                              value={mntAmount}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              sx={{
                                "& .MuiInputBase-input::placeholder": {
                                  color: userDetails.show_timer
                                    ? "white"
                                    : "inherit",
                                  opacity: 1,
                                },
                                "& .Mui-disabled": {
                                  color: "white",
                                },
                              }}
                              onKeyPress={(event) => {
                                if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onPaste={handleChange}
                              onChange={inputHandler}
                            />
                          </div>

                          <button
                            disabled={userDetails.show_timer}
                            onClick={maxToken}
                            className="pull-right text-white px-4 btn btn-main2 maxamount rounded-2"
                            type="button"
                          >
                            MAX
                          </button>
                        </div>

                        {userDetails?.show_timer && (
                          <div className="mt-2 text-end">
                            <CountdownTimer
                              timeDuration={userDetails?.time_duration} type="transfer"
                            />
                          </div>
                        )}

                        {/* <br/> */}
                        {validationError.withdrawAmountError && (
                          <div style={{ marginTop: 8 }}>
                            <span
                              className="validationErr "
                              style={{
                                color: "red",
                                marginTop: "5px",
                                marginBottom: 5,
                                fontSize: 14,
                              }}
                            >
                              {validationError.withdrawAmountError ? (
                                validationError.withdrawAmountError
                              ) : (
                                <span style={{ visibility: "hidden" }}> .</span>
                              )}
                            </span>
                          </div>
                        )}
                        <div className="d-flex gap-2 mt-3">
                          <div style={{ width: 15 }}>
                            <input
                              className="custom-checkbox mt-1"
                              style={{ width: 15, height: 15 }}
                              type="checkbox"
                              onChange={() => setIsChecked(!isChecked)} // Toggle checkbox state
                              //   checked={termsAndConditionsCheck}
                              //   onChange={inputHandler}
                              name="checkbox"
                              id="flexCheckDefault"
                            />
                          </div>
                          <div className="d-flex gap-1">
                            <p style={{ marginTop: "1px" }} className="mb-0">
                              I Agree with the
                            </p>
                            <Link
                              target="blank"
                              className=" tnc"
                              to={`${config.baseUrl}signuptermsandconditions`}
                            >
                              Terms & Conditions{" "}
                            </Link>
                          </div>
                        </div>
                        <div className="mb-4 mt-2">
                          <h6 className="mb-1">
                            <small className="text-light-grey">Fee 5% </small>
                          </h6>

                          <h6>
                            <small className="text-light-grey">
                              Receiver will get :{" "}
                              {!mntAmount || isNaN(mntAmount)
                                ? "0.00"
                                : (mntAmount * (1 - 5 / 100)).toFixed(2)}
                              &nbsp;ANANT
                            </small>
                          </h6>
                        </div>

                        <div
                          className="w-100 tooltip-container"
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        >
                          <Button
                            variant="main2"
                            className="w-100 mb-3"
                            onClick={handleShowModal}
                            disabled={userDetails?.show_timer || userDetails?.is_transfer_allow == false}
                          >
                            Send
                          </Button>
                          {/* {showTooltip && !userDetails?.is_withdraw_allow && (
                            <div className="tooltip">{userDetails?.message}</div>
                          )} */}
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            marginTop: "2.5px",
                            color: "white",
                          }}
                        >
                          {userDetails?.note}
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: userDetails.transfer_limit_msg,
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={6} className="mt-3">
                      <div>
                        <img
                          src="assets/images/withdraw.png"
                          width="100%"
                          alt=""
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Container>
          </div>
          {
            <SendCreditOtpModal showModal={showModal} setshowModal={setshowModal} setIsTimerActive={setIsTimerActive}
              isTimerActive={isTimerActive}
              timer={timer}
              setTimer={setTimer} email={email} loading={loading} transferFunc={transferFunc} setOtp={setOtp} otp={otp} otpIs={otpIs} setOtpIs={setOtpIs} sendCreditTransfer={sendCreditTransfer}/>
          }
          {/* ---------- */}
        </div>
      </div>
    </>
  );
};
export default CreditTransfer;
